import Image, { ImageProps } from "next/image";
import DefaultImage from "./default_cover.png";
import { cn } from "@/lib/utils";

export function DirectusImage(
  props: {
    id: string;
    zoomIn?: boolean;
    zoomInGroup?: boolean;
    defaultImage?: string;
  } & Omit<ImageProps, "src">
) {
  const {
    id,
    alt,
    zoomIn,
    zoomInGroup,
    className,
    defaultImage,
    ...otherProps
  } = props;
  return (
    <Image
      quality={85}
      {...otherProps}
      alt={alt ?? ""}
      placeholder={id ? "blur" : undefined}
      blurDataURL={
        id
          ? `${process.env.NEXT_PUBLIC_ASSETS}/${id}?transforms=[["blur",70]]`
          : undefined
      }
      className={cn(className, {
        "hover:scale-105 duration-300 origin-center": zoomIn,
        "group-hover:scale-105 duration-300 origin-center": zoomInGroup,
      })}
      src={
        id
          // ? `${process.env.NEXT_PUBLIC_ASSETS}/${id}`
          ? `${process.env.NEXT_PUBLIC_ASSETS}/${id}`
          : defaultImage ?? DefaultImage
      }
    />
  );
}
